import { Wrapper } from "@googlemaps/react-wrapper";

export default Wrapper;
